import React from 'react'
import ReactExport from 'react-export-excel'
import reportsApi from '../../../api/reports-api'
import { Button } from 'react-bootstrap'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

class ViberBotBulkExport extends React.Component {
  constructor(props) {
    super(props)

    this.sate = {
      statistics: [],
    }
  }

  async componentDidMount() {
    try {
      const result = await reportsApi.exportViberBulk(this.props.id)
      this.setState({ statistics: result })
    } catch (error) {
      throw error
    }
  }

  render() {
    return (
      <ExcelFile
        filename="Вибер булк репорт"
        element={
          <Button variant="btn mr-2 button-standard">Експортирај</Button>
        }
      >
        {this.state && this.state.statistics != null ? (
          <ExcelSheet data={this.state.statistics} name="statistics">
            <ExcelColumn label="Телефон" value="phone" />
            <ExcelColumn label="Текст" value="text" />
            <ExcelColumn label="Статус" value="status" />
            <ExcelColumn label="Втор статус" value="subStatus" />
            <ExcelColumn label="Потпис" value="signature" />
            <ExcelColumn label="Датум" value="date" />
          </ExcelSheet>
        ) : null}
      </ExcelFile>
    )
  }
}
export default ViberBotBulkExport
